import React, { useCallback, useEffect } from "react";
import IconNegada from "../componentsStyled/icon/Iconnegada";
import { Box, Button, Modal } from "@mui/material";

interface ModalNotProductProps {
  isOpen: boolean;
  children?: React.ReactNode;
  onInterval?: () => void;
}

const ModalNotProduct: React.FC<ModalNotProductProps> = ({ isOpen }) => {
  return (
    <Modal
      open={isOpen}
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 350,
        height: 300,
        bgcolor: "#fff",
        boxShadow: 24,
        "& .MuiBackdrop-root": { backgroundColor: "transparent" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        borderRadius: 10,
      }}>
      <Box width={300} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} textAlign={"center"}>
        <IconNegada width={60}></IconNegada>
        <p style={{ fontSize: 22 }}>Poxa,Craque!</p>
        <p>Parece que você ainda não tem nenhum pedido! Acesse nosso site e conheça nossos milhares de produtos</p>
        <Button variant="contained" style={{ backgroundColor: "#000" }} href="https://https://www.kappa.com.br/">
          Acessar
        </Button>
      </Box>
    </Modal>
  );
};

export default ModalNotProduct;
